<div class="d-flex flex-wrap justify-content-between mb-5 w-100">
  <div class="search-container mx-0">
    <div class="search-text d-flex">
      <input type="text" [formControl]="searchControl" class="search" [placeholder]="placeholder">
    </div>
    <span class="search-icon"><i class="fa fa-search"></i></span>
  </div>
</div>